var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconScanQr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 38,
    height: 34,
    viewBox: "0 0 38 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Icon-scan-qr"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 34
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-3"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-4"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-5"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-6"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-7"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-8"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-9"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-10"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-10"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-11"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-11"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-12"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-12"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-13"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-13"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-14"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-14"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-15"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-15"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-16"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-16"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-17"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-17"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-18"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-18"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-19"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-19"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-20"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-20"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-21"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-21"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-22"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-22"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-23"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-23"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-24"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-24"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-25"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-25"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-26"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-26"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-27"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-27"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-28"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-28"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-29"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-29"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-30"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-30"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-31"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-31"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-32"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-32"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-33"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-33"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-34"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-34"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-35"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-35"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-36"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-36"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-37"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-37"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-38"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-38"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-39"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-39"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-40"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-40"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-41"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-41"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-42"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-42"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-43"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-43"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-44"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-44"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-45"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-45"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-46"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-46"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-47"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-47"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-48"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-48"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-49"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-49"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-50"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-50"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-51"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-51"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-52"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-52"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-53"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-53"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-54"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-54"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-55"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-55"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-56"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-56"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-57"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-57"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-scan-qr",
    clipPath: "url(#clip-Icon-scan-qr)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5306",
    "data-name": "Group 5306",
    transform: "translate(-66.758 -27.146)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5301",
    "data-name": "Group 5301",
    transform: "translate(74.259 33.313)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2066",
    "data-name": "Rectangle 2066",
    transform: "translate(0.044)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.671,
    height: 6.671,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.55,
    y: 0.55,
    width: 5.571,
    height: 5.571,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2669",
    "data-name": "Rectangle 2669",
    width: 2.08,
    height: 2.08,
    transform: "translate(2.339 2.296)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5308",
    "data-name": "Group 5308",
    transform: "translate(74.259 48.768)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2066-2",
    "data-name": "Rectangle 2066",
    transform: "translate(0.044)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.671,
    height: 6.671,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.55,
    y: 0.55,
    width: 5.571,
    height: 5.571,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2669-2",
    "data-name": "Rectangle 2669",
    width: 2.08,
    height: 2.08,
    transform: "translate(2.339 2.296)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5307",
    "data-name": "Group 5307",
    transform: "translate(89.719 33.313)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2066-3",
    "data-name": "Rectangle 2066",
    transform: "translate(0.044)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.671,
    height: 6.671,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.55,
    y: 0.55,
    width: 5.571,
    height: 5.571,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2669-3",
    "data-name": "Rectangle 2669",
    width: 2.08,
    height: 2.08,
    transform: "translate(2.339 2.296)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1934",
    "data-name": "Path 1934",
    d: "M-.064,8.395V3.889A3.292,3.292,0,0,1,1.09,1.564,3.842,3.842,0,0,1,3.481.482H7.809",
    transform: "translate(70.934 29.207)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1937",
    "data-name": "Path 1937",
    d: "M7.809.482V4.988A3.292,3.292,0,0,1,6.655,7.312,3.842,3.842,0,0,1,4.264,8.395H-.064",
    transform: "translate(92.101 50.207)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1935",
    "data-name": "Path 1935",
    d: "M7.809,8.395V3.889A3.292,3.292,0,0,0,6.655,1.564,3.842,3.842,0,0,0,4.264.482H-.064",
    transform: "translate(92.102 29.207)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1936",
    "data-name": "Path 1936",
    d: "M-.064.482V4.988A3.292,3.292,0,0,0,1.09,7.312,3.842,3.842,0,0,0,3.481,8.395H7.809",
    transform: "translate(70.934 50.207)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2737",
    "data-name": "Rectangle 2737",
    transform: "translate(80.975 47.654) rotate(-90)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill",
    width: 1.112,
    height: 1.112,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.11169373989105225h1.1118364334106445M1,0v1.1116937398910522M1.1118364334106445,1h-1.1118364334106445M0.11183643341064453,1.1116937398910522v-1.1116937398910522",
    fill: "none",
    clipPath: "url(#clip)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2728",
    "data-name": "Rectangle 2728",
    transform: "translate(77.64 47.654) rotate(-90)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-2",
    width: 1.112,
    height: 1.112,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.11169373989105225h1.1118364334106445M1,0v1.1116937398910522M1.1118364334106445,1h-1.1118364334106445M0.11183643341064453,1.1116937398910522v-1.1116937398910522",
    fill: "none",
    clipPath: "url(#clip-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2722",
    "data-name": "Rectangle 2722",
    transform: "translate(76.528 47.654) rotate(-90)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-3",
    width: 1.112,
    height: 1.112,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.11169373989105225h1.1118364334106445M1,0v1.1116937398910522M1.1118364334106445,1h-1.1118364334106445M0.11183643341064453,1.1116937398910522v-1.1116937398910522",
    fill: "none",
    clipPath: "url(#clip-3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2719",
    "data-name": "Rectangle 2719",
    transform: "translate(75.415 47.654) rotate(-90)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-4",
    width: 1.112,
    height: 1.112,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.11169373989105225h1.1118364334106445M1,0v1.1116937398910522M1.1118364334106445,1h-1.1118364334106445M0.11183643341064453,1.1116937398910522v-1.1116937398910522",
    fill: "none",
    clipPath: "url(#clip-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2701",
    "data-name": "Rectangle 2701",
    transform: "translate(81.978 40.98)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-5",
    width: 1.112,
    height: 1.112,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.11169373989105225h1.1118364334106445M1,0v1.1116937398910522M1.1118364334106445,1h-1.1118364334106445M0.11183643341064453,1.1116937398910522v-1.1116937398910522",
    fill: "none",
    clipPath: "url(#clip-5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2707",
    "data-name": "Rectangle 2707",
    transform: "translate(88.651 40.98)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-6",
    width: 1.112,
    height: 1.112,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.11169373989105225h1.1118364334106445M1,0v1.1116937398910522M1.1118364334106445,1h-1.1118364334106445M0.11183643341064453,1.1116937398910522v-1.1116937398910522",
    fill: "none",
    clipPath: "url(#clip-6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2693",
    "data-name": "Rectangle 2693",
    transform: "translate(81.978 37.646)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-7",
    width: 1.112,
    height: 1.112,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.11169373989105225h1.1118364334106445M1,0v1.1116937398910522M1.1118364334106445,1h-1.1118364334106445M0.11183643341064453,1.1116937398910522v-1.1116937398910522",
    fill: "none",
    clipPath: "url(#clip-7)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2687",
    "data-name": "Rectangle 2687",
    transform: "translate(81.978 35.424)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-8",
    width: 1.112,
    height: 1.112,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.11169373989105225h1.1118364334106445M1,0v1.1116937398910522M1.1118364334106445,1h-1.1118364334106445M0.11183643341064453,1.1116937398910522v-1.1116937398910522",
    fill: "none",
    clipPath: "url(#clip-8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2684",
    "data-name": "Rectangle 2684",
    transform: "translate(81.978 34.313)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-9",
    width: 1.112,
    height: 1.112,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.11169373989105225h1.1118364334106445M1,0v1.1116937398910522M1.1118364334106445,1h-1.1118364334106445M0.11183643341064453,1.1116937398910522v-1.1116937398910522",
    fill: "none",
    clipPath: "url(#clip-9)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2740",
    "data-name": "Rectangle 2740",
    transform: "translate(83.198 46.542) rotate(180)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-10",
    width: 1.112,
    height: 1.112,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.11169373989105225h1.1118364334106445M1,0v1.1116937398910522M1.1118364334106445,1h-1.1118364334106445M0.11183643341064453,1.1116937398910522v-1.1116937398910522",
    fill: "none",
    clipPath: "url(#clip-10)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2745",
    "data-name": "Rectangle 2745",
    transform: "translate(83.198 50.987) rotate(180)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-11",
    width: 1.112,
    height: 1.112,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.11169373989105225h1.1118364334106445M1,0v1.1116937398910522M1.1118364334106445,1h-1.1118364334106445M0.11183643341064453,1.1116937398910522v-1.1116937398910522",
    fill: "none",
    clipPath: "url(#clip-11)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2741",
    "data-name": "Rectangle 2741",
    transform: "translate(83.198 48.765) rotate(180)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-12",
    width: 1.112,
    height: 1.112,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.11169373989105225h1.1118364334106445M1,0v1.1116937398910522M1.1118364334106445,1h-1.1118364334106445M0.11183643341064453,1.1116937398910522v-1.1116937398910522",
    fill: "none",
    clipPath: "url(#clip-12)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2746",
    "data-name": "Rectangle 2746",
    transform: "translate(83.198 53.214) rotate(180)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-13",
    width: 1.112,
    height: 1.112,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.11169373989105225h1.1118364334106445M1,0v1.1116937398910522M1.1118364334106445,1h-1.1118364334106445M0.11183643341064453,1.1116937398910522v-1.1116937398910522",
    fill: "none",
    clipPath: "url(#clip-13)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2733",
    "data-name": "Rectangle 2733",
    transform: "translate(80.966 46.542) rotate(180)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-14",
    width: 1.112,
    height: 1.112,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.11169373989105225h1.1118364334106445M1,0v1.1116937398910522M1.1118364334106445,1h-1.1118364334106445M0.11183643341064453,1.1116937398910522v-1.1116937398910522",
    fill: "none",
    clipPath: "url(#clip-14)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2727",
    "data-name": "Rectangle 2727",
    transform: "translate(78.751 46.542) rotate(180)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-15",
    width: 1.112,
    height: 1.112,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.11169373989105225h1.1118364334106445M1,0v1.1116937398910522M1.1118364334106445,1h-1.1118364334106445M0.11183643341064453,1.1116937398910522v-1.1116937398910522",
    fill: "none",
    clipPath: "url(#clip-15)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2698",
    "data-name": "Rectangle 2698",
    transform: "translate(83.09 40.981) rotate(-90)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-16",
    width: 1.112,
    height: 1.112,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.11169373989105225h1.1118364334106445M1,0v1.1116937398910522M1.1118364334106445,1h-1.1118364334106445M0.11183643341064453,1.1116937398910522v-1.1116937398910522",
    fill: "none",
    clipPath: "url(#clip-16)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2694",
    "data-name": "Rectangle 2694",
    transform: "translate(83.09 38.758) rotate(-90)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-17",
    width: 1.112,
    height: 1.112,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.11169373989105225h1.1118364334106445M1,0v1.1116937398910522M1.1118364334106445,1h-1.1118364334106445M0.11183643341064453,1.1116937398910522v-1.1116937398910522",
    fill: "none",
    clipPath: "url(#clip-17)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2690",
    "data-name": "Rectangle 2690",
    transform: "translate(83.09 37.647) rotate(-90)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-18",
    width: 1.112,
    height: 1.112,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.11169373989105225h1.1118364334106445M1,0v1.1116937398910522M1.1118364334106445,1h-1.1118364334106445M0.11183643341064453,1.1116937398910522v-1.1116937398910522",
    fill: "none",
    clipPath: "url(#clip-18)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2681",
    "data-name": "Rectangle 2681",
    transform: "translate(83.09 34.424) rotate(-90)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-19",
    width: 1.112,
    height: 1.112,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.11169373989105225h1.1118364334106445M1,0v1.1116937398910522M1.1118364334106445,1h-1.1118364334106445M0.11183643341064453,1.1116937398910522v-1.1116937398910522",
    fill: "none",
    clipPath: "url(#clip-19)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2736",
    "data-name": "Rectangle 2736",
    transform: "translate(82.086 45.431) rotate(180)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-20",
    width: 1.112,
    height: 1.112,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.11169373989105225h1.1118364334106445M1,0v1.1116937398910522M1.1118364334106445,1h-1.1118364334106445M0.11183643341064453,1.1116937398910522v-1.1116937398910522",
    fill: "none",
    clipPath: "url(#clip-20)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2730",
    "data-name": "Rectangle 2730",
    transform: "translate(79.854 45.431) rotate(180)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-21",
    width: 1.112,
    height: 1.112,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.11169373989105225h1.1118364334106445M1,0v1.1116937398910522M1.1118364334106445,1h-1.1118364334106445M0.11183643341064453,1.1116937398910522v-1.1116937398910522",
    fill: "none",
    clipPath: "url(#clip-21)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2726",
    "data-name": "Rectangle 2726",
    transform: "translate(78.751 45.431) rotate(180)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-22",
    width: 1.112,
    height: 1.112,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.11169373989105225h1.1118364334106445M1,0v1.1116937398910522M1.1118364334106445,1h-1.1118364334106445M0.11183643341064453,1.1116937398910522v-1.1116937398910522",
    fill: "none",
    clipPath: "url(#clip-22)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2721",
    "data-name": "Rectangle 2721",
    transform: "translate(77.639 45.431) rotate(180)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-23",
    width: 1.112,
    height: 1.112,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.11169373989105225h1.1118364334106445M1,0v1.1116937398910522M1.1118364334106445,1h-1.1118364334106445M0.11183643341064453,1.1116937398910522v-1.1116937398910522",
    fill: "none",
    clipPath: "url(#clip-23)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2718",
    "data-name": "Rectangle 2718",
    transform: "translate(76.526 45.431) rotate(180)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-24",
    width: 1.112,
    height: 1.112,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.11169373989105225h1.1118364334106445M1,0v1.1116937398910522M1.1118364334106445,1h-1.1118364334106445M0.11183643341064453,1.1116937398910522v-1.1116937398910522",
    fill: "none",
    clipPath: "url(#clip-24)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2715",
    "data-name": "Rectangle 2715",
    transform: "translate(75.415 45.431) rotate(180)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-25",
    width: 1.112,
    height: 1.112,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.11169373989105225h1.1118364334106445M1,0v1.1116937398910522M1.1118364334106445,1h-1.1118364334106445M0.11183643341064453,1.1116937398910522v-1.1116937398910522",
    fill: "none",
    clipPath: "url(#clip-25)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2702",
    "data-name": "Rectangle 2702",
    transform: "translate(84.201 42.092) rotate(-90)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-26",
    width: 1.112,
    height: 1.112,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.11169373989105225h1.1118364334106445M1,0v1.1116937398910522M1.1118364334106445,1h-1.1118364334106445M0.11183643341064453,1.1116937398910522v-1.1116937398910522",
    fill: "none",
    clipPath: "url(#clip-26)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2706",
    "data-name": "Rectangle 2706",
    transform: "translate(90.874 42.092) rotate(-90)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-27",
    width: 1.112,
    height: 1.112,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.11169373989105225h1.1118364334106445M1,0v1.1116937398910522M1.1118364334106445,1h-1.1118364334106445M0.11183643341064453,1.1116937398910522v-1.1116937398910522",
    fill: "none",
    clipPath: "url(#clip-27)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2688",
    "data-name": "Rectangle 2688",
    transform: "translate(84.201 36.535) rotate(-90)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-28",
    width: 1.112,
    height: 1.112,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.11169373989105225h1.1118364334106445M1,0v1.1116937398910522M1.1118364334106445,1h-1.1118364334106445M0.11183643341064453,1.1116937398910522v-1.1116937398910522",
    fill: "none",
    clipPath: "url(#clip-28)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2685",
    "data-name": "Rectangle 2685",
    transform: "translate(84.201 35.424) rotate(-90)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-29",
    width: 1.112,
    height: 1.112,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.11169373989105225h1.1118364334106445M1,0v1.1116937398910522M1.1118364334106445,1h-1.1118364334106445M0.11183643341064453,1.1116937398910522v-1.1116937398910522",
    fill: "none",
    clipPath: "url(#clip-29)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2682",
    "data-name": "Rectangle 2682",
    transform: "translate(84.201 34.424) rotate(-90)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-30",
    width: 1.112,
    height: 1.112,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.11169373989105225h1.1118364334106445M1,0v1.1116937398910522M1.1118364334106445,1h-1.1118364334106445M0.11183643341064453,1.1116937398910522v-1.1116937398910522",
    fill: "none",
    clipPath: "url(#clip-30)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2739",
    "data-name": "Rectangle 2739",
    transform: "translate(83.198 44.317) rotate(180)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-31",
    width: 1.112,
    height: 1.112,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.11169373989105225h1.1118364334106445M1,0v1.1116937398910522M1.1118364334106445,1h-1.1118364334106445M0.11183643341064453,1.1116937398910522v-1.1116937398910522",
    fill: "none",
    clipPath: "url(#clip-31)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2735",
    "data-name": "Rectangle 2735",
    transform: "translate(82.086 44.317) rotate(180)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-32",
    width: 1.112,
    height: 1.112,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.11169373989105225h1.1118364334106445M1,0v1.1116937398910522M1.1118364334106445,1h-1.1118364334106445M0.11183643341064453,1.1116937398910522v-1.1116937398910522",
    fill: "none",
    clipPath: "url(#clip-32)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2725",
    "data-name": "Rectangle 2725",
    transform: "translate(78.751 44.317) rotate(180)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-33",
    width: 1.112,
    height: 1.112,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.11169373989105225h1.1118364334106445M1,0v1.1116937398910522M1.1118364334106445,1h-1.1118364334106445M0.11183643341064453,1.1116937398910522v-1.1116937398910522",
    fill: "none",
    clipPath: "url(#clip-33)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2717",
    "data-name": "Rectangle 2717",
    transform: "translate(76.526 44.317) rotate(180)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-34",
    width: 1.112,
    height: 1.112,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.11169373989105225h1.1118364334106445M1,0v1.1116937398910522M1.1118364334106445,1h-1.1118364334106445M0.11183643341064453,1.1116937398910522v-1.1116937398910522",
    fill: "none",
    clipPath: "url(#clip-34)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2699",
    "data-name": "Rectangle 2699",
    transform: "translate(85.314 40.981) rotate(-90)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-35",
    width: 1.112,
    height: 1.112,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.11169373989105225h1.1118364334106445M1,0v1.1116937398910522M1.1118364334106445,1h-1.1118364334106445M0.11183643341064453,1.1116937398910522v-1.1116937398910522",
    fill: "none",
    clipPath: "url(#clip-35)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2695",
    "data-name": "Rectangle 2695",
    transform: "translate(85.314 38.758) rotate(-90)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-36",
    width: 1.112,
    height: 1.112,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.11169373989105225h1.1118364334106445M1,0v1.1116937398910522M1.1118364334106445,1h-1.1118364334106445M0.11183643341064453,1.1116937398910522v-1.1116937398910522",
    fill: "none",
    clipPath: "url(#clip-36)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2689",
    "data-name": "Rectangle 2689",
    transform: "translate(85.314 36.535) rotate(-90)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-37",
    width: 1.112,
    height: 1.112,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.11169373989105225h1.1118364334106445M1,0v1.1116937398910522M1.1118364334106445,1h-1.1118364334106445M0.11183643341064453,1.1116937398910522v-1.1116937398910522",
    fill: "none",
    clipPath: "url(#clip-37)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2734",
    "data-name": "Rectangle 2734",
    transform: "translate(82.086 43.206) rotate(180)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-38",
    width: 1.112,
    height: 1.112,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.11169373989105225h1.1118364334106445M1,0v1.1116937398910522M1.1118364334106445,1h-1.1118364334106445M0.11183643341064453,1.1116937398910522v-1.1116937398910522",
    fill: "none",
    clipPath: "url(#clip-38)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2732",
    "data-name": "Rectangle 2732",
    transform: "translate(80.966 43.206) rotate(180)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-39",
    width: 1.112,
    height: 1.112,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.11169373989105225h1.1118364334106445M1,0v1.1116937398910522M1.1118364334106445,1h-1.1118364334106445M0.11183643341064453,1.1116937398910522v-1.1116937398910522",
    fill: "none",
    clipPath: "url(#clip-39)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2729",
    "data-name": "Rectangle 2729",
    transform: "translate(79.854 43.206) rotate(180)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-40",
    width: 1.112,
    height: 1.112,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.11169373989105225h1.1118364334106445M1,0v1.1116937398910522M1.1118364334106445,1h-1.1118364334106445M0.11183643341064453,1.1116937398910522v-1.1116937398910522",
    fill: "none",
    clipPath: "url(#clip-40)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2724",
    "data-name": "Rectangle 2724",
    transform: "translate(78.751 43.206) rotate(180)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-41",
    width: 1.112,
    height: 1.112,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.11169373989105225h1.1118364334106445M1,0v1.1116937398910522M1.1118364334106445,1h-1.1118364334106445M0.11183643341064453,1.1116937398910522v-1.1116937398910522",
    fill: "none",
    clipPath: "url(#clip-41)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2714",
    "data-name": "Rectangle 2714",
    transform: "translate(75.415 43.206) rotate(180)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-42",
    width: 1.112,
    height: 1.112,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.11169373989105225h1.1118364334106445M1,0v1.1116937398910522M1.1118364334106445,1h-1.1118364334106445M0.11183643341064453,1.1116937398910522v-1.1116937398910522",
    fill: "none",
    clipPath: "url(#clip-42)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2703",
    "data-name": "Rectangle 2703",
    transform: "translate(86.426 42.092) rotate(-90)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-43",
    width: 1.112,
    height: 1.112,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.11169373989105225h1.1118364334106445M1,0v1.1116937398910522M1.1118364334106445,1h-1.1118364334106445M0.11183643341064453,1.1116937398910522v-1.1116937398910522",
    fill: "none",
    clipPath: "url(#clip-43)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2705",
    "data-name": "Rectangle 2705",
    transform: "translate(93.099 42.092) rotate(-90)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-44",
    width: 1.112,
    height: 1.112,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.11169373989105225h1.1118364334106445M1,0v1.1116937398910522M1.1118364334106445,1h-1.1118364334106445M0.11183643341064453,1.1116937398910522v-1.1116937398910522",
    fill: "none",
    clipPath: "url(#clip-44)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2697",
    "data-name": "Rectangle 2697",
    transform: "translate(86.426 39.869) rotate(-90)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-45",
    width: 1.112,
    height: 1.112,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.11169373989105225h1.1118364334106445M1,0v1.1116937398910522M1.1118364334106445,1h-1.1118364334106445M0.11183643341064453,1.1116937398910522v-1.1116937398910522",
    fill: "none",
    clipPath: "url(#clip-45)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2696",
    "data-name": "Rectangle 2696",
    transform: "translate(86.426 38.758) rotate(-90)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-46",
    width: 1.112,
    height: 1.112,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.11169373989105225h1.1118364334106445M1,0v1.1116937398910522M1.1118364334106445,1h-1.1118364334106445M0.11183643341064453,1.1116937398910522v-1.1116937398910522",
    fill: "none",
    clipPath: "url(#clip-46)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2691",
    "data-name": "Rectangle 2691",
    transform: "translate(86.426 37.647) rotate(-90)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-47",
    width: 1.112,
    height: 1.112,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.11169373989105225h1.1118364334106445M1,0v1.1116937398910522M1.1118364334106445,1h-1.1118364334106445M0.11183643341064453,1.1116937398910522v-1.1116937398910522",
    fill: "none",
    clipPath: "url(#clip-47)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2738",
    "data-name": "Rectangle 2738",
    transform: "translate(83.198 42.092) rotate(180)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-48",
    width: 1.112,
    height: 1.112,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.11169373989105225h1.1118364334106445M1,0v1.1116937398910522M1.1118364334106445,1h-1.1118364334106445M0.11183643341064453,1.1116937398910522v-1.1116937398910522",
    fill: "none",
    clipPath: "url(#clip-48)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2731",
    "data-name": "Rectangle 2731",
    transform: "translate(80.966 42.092) rotate(180)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-49",
    width: 1.112,
    height: 1.112,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.11169373989105225h1.1118364334106445M1,0v1.1116937398910522M1.1118364334106445,1h-1.1118364334106445M0.11183643341064453,1.1116937398910522v-1.1116937398910522",
    fill: "none",
    clipPath: "url(#clip-49)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2723",
    "data-name": "Rectangle 2723",
    transform: "translate(78.751 42.092) rotate(180)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-50",
    width: 1.112,
    height: 1.112,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.11169373989105225h1.1118364334106445M1,0v1.1116937398910522M1.1118364334106445,1h-1.1118364334106445M0.11183643341064453,1.1116937398910522v-1.1116937398910522",
    fill: "none",
    clipPath: "url(#clip-50)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2720",
    "data-name": "Rectangle 2720",
    transform: "translate(77.639 42.092) rotate(180)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-51",
    width: 1.112,
    height: 1.112,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.11169373989105225h1.1118364334106445M1,0v1.1116937398910522M1.1118364334106445,1h-1.1118364334106445M0.11183643341064453,1.1116937398910522v-1.1116937398910522",
    fill: "none",
    clipPath: "url(#clip-51)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2716",
    "data-name": "Rectangle 2716",
    transform: "translate(76.526 42.092) rotate(180)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-52",
    width: 1.112,
    height: 1.112,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.11169373989105225h1.1118364334106445M1,0v1.1116937398910522M1.1118364334106445,1h-1.1118364334106445M0.11183643341064453,1.1116937398910522v-1.1116937398910522",
    fill: "none",
    clipPath: "url(#clip-52)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2704",
    "data-name": "Rectangle 2704",
    transform: "translate(87.539 42.092) rotate(-90)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-53",
    width: 1.112,
    height: 1.112,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.11169373989105225h1.1118364334106445M1,0v1.1116937398910522M1.1118364334106445,1h-1.1118364334106445M0.11183643341064453,1.1116937398910522v-1.1116937398910522",
    fill: "none",
    clipPath: "url(#clip-53)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2700",
    "data-name": "Rectangle 2700",
    transform: "translate(87.539 40.98) rotate(-90)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-54",
    width: 1.112,
    height: 1.112,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.11169373989105225h1.1118364334106445M1,0v1.1116937398910522M1.1118364334106445,1h-1.1118364334106445M0.11183643341064453,1.1116937398910522v-1.1116937398910522",
    fill: "none",
    clipPath: "url(#clip-54)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2692",
    "data-name": "Rectangle 2692",
    transform: "translate(87.539 37.646) rotate(-90)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-55",
    width: 1.112,
    height: 1.112,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.11169373989105225h1.1118364334106445M1,0v1.1116937398910522M1.1118364334106445,1h-1.1118364334106445M0.11183643341064453,1.1116937398910522v-1.1116937398910522",
    fill: "none",
    clipPath: "url(#clip-55)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2686",
    "data-name": "Rectangle 2686",
    transform: "translate(87.539 35.424) rotate(-90)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-56",
    width: 1.112,
    height: 1.112,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.11169373989105225h1.1118364334106445M1,0v1.1116937398910522M1.1118364334106445,1h-1.1118364334106445M0.11183643341064453,1.1116937398910522v-1.1116937398910522",
    fill: "none",
    clipPath: "url(#clip-56)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2683",
    "data-name": "Rectangle 2683",
    transform: "translate(87.539 34.424) rotate(-90)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-57",
    width: 1.112,
    height: 1.112,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.11169373989105225h1.1118364334106445M1,0v1.1116937398910522M1.1118364334106445,1h-1.1118364334106445M0.11183643341064453,1.1116937398910522v-1.1116937398910522",
    fill: "none",
    clipPath: "url(#clip-57)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "search",
    transform: "translate(84.331 43.207)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_824",
    "data-name": "Path 824",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.683,0A4.659,4.659,0,0,1,9.366,4.636,4.659,4.659,0,0,1,4.683,9.271,4.659,4.659,0,0,1,0,4.636,4.659,4.659,0,0,1,4.683,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4.682843685150146 1.500003814697266 C 2.927823543548584 1.500003814697266 1.500003814697266 2.906683444976807 1.500003814697266 4.63572359085083 C 1.500003814697266 6.364763259887695 2.927823543548584 7.771443367004395 4.682843685150146 7.771443367004395 C 6.437863349914551 7.771443367004395 7.865683555603027 6.364763259887695 7.865683555603027 4.63572359085083 C 7.865683555603027 2.906683444976807 6.437863349914551 1.500003814697266 4.682843685150146 1.500003814697266 M 4.682843685150146 3.814697265625e-06 C 7.26910400390625 3.814697265625e-06 9.365683555603027 2.075483798980713 9.365683555603027 4.63572359085083 C 9.365683555603027 7.195963859558105 7.26910400390625 9.271443367004395 4.682843685150146 9.271443367004395 C 2.096583843231201 9.271443367004395 3.814697265625e-06 7.195963859558105 3.814697265625e-06 4.63572359085083 C 3.814697265625e-06 2.075483798980713 2.096583843231201 3.814697265625e-06 4.682843685150146 3.814697265625e-06 Z",
    stroke: "none",
    fill: "#040404"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_573",
    "data-name": "Line 573",
    x2: 3.263,
    y2: 3.771,
    transform: "translate(7.603 8)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconScanQr);
export default __webpack_public_path__ + "static/media/Icon-scan-qr.99414c0a2eea69803ed08fe0f21c9a28.svg";
export { ForwardRef as ReactComponent };